<template>
	<div class="pcindexc-content">
		<div v-for="(item,index) in content" class="img-item" @click="todetails(item.id)">
			<img :src="item.image" />
		</div>
	</div>
</template>

<script>
	export default{
		props:['content'],
		methods:{
			todetails(id){
				this.$emit('jump',id);//1.向外部触发一个事件
			}
		},
		mounted(){
			// console.log('contentcontentcontent',this.content)
		}
	}
</script>
<style scoped>

	.img-item:nth-child(2n){
		margin-left: 40px;

	}
	.img-item{
		margin-top: 40px;
		width: 460px;
		height: 220px;
		overflow: hidden;
		border-radius: 20px;
	}
	.img-item img{
		width: 100%;
		height: 100%;
		transition: all .75s ease-in-out; 
	}
	.img-item:hover img{
		transform: scale(1.02,1.02);  
	}
</style>
